module.exports = new __parcel__URL__("timeline-preview.cf56bfbb.svg").toString();